import {
  Box,
  Divider,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material"
import { blueGrey } from "@mui/material/colors"
import { ArrowRight } from "lucide-react"
import { useState } from "react"
import { BlockMath, InlineMath } from "react-katex"

export function PrinciplesImpactCalculation() {
  const [simpleMath, setSimpleMath] = useState(false)

  return (
    <>
      <Typography variant="body2">
        Após a submissão das respostas de um questionário AIA por uma
        organização, a aplicação tem um cálculo de impacto para cada princípio
        ético do questionário.
      </Typography>

      <Typography variant="body2">
        Após a submissão das respostas de um questionário AIA por uma
        organização, a aplicação tem um cálculo de impacto para cada princípio
        ético do questionário.
      </Typography>

      <Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2" color={blueGrey[700]} fontWeight={600}>
              Fórmula de Cálculo dos Princípios Éticos
            </Typography>

            <FormControlLabel
              slotProps={{
                typography: {
                  sx: {
                    paddingLeft: 0.5,
                    fontSize: "0.8rem",
                  },
                },
              }}
              control={
                <Switch
                  size="small"
                  value={simpleMath}
                  onChange={() => setSimpleMath(!simpleMath)}
                />
              }
              label="Simplificada"
            />
          </Box>

          <Box>
            {simpleMath ? (
              <Box sx={{ fontSize: "0.75rem", color: blueGrey[900] }}>
                <BlockMath
                  math={
                    "\\text{Pontuação}_{\\text {princípio}} = \\frac{\\text{Somatório (Alternativas Marcadas × Peso da Questão)}}{\\text{Somatório (Impacto Máximo × Peso da Questão)}} \\times 100"
                  }
                />
              </Box>
            ) : (
              <Box sx={{ color: blueGrey[900] }}>
                <BlockMath
                  math={
                    "P_e = \\frac{\\sum_{i=1}^{n} \\left( \\sum a_{k \\in S_i} \\times w_i \\right)}{\\sum_{i=1}^{n} \\left( I_{i}^{max} \\times w_i \\right)} \\times 100"
                  }
                />
              </Box>
            )}

            {!simpleMath && (
              <Typography
                component={"p"}
                variant="caption"
                color={blueGrey[600]}
                textAlign={"center"}
              >
                Por princípio ético
              </Typography>
            )}
          </Box>

          {!simpleMath && (
            <Box>
              <Typography variant="body2">Onde:</Typography>
              <ul style={{ paddingLeft: 24, margin: 0, paddingTop: 8 }}>
                <li>
                  <Typography variant="body2">
                    <InlineMath math={"P_e"} /> = Pontuação do princípio ético{" "}
                    <InlineMath math={"e"} /> (%)
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <InlineMath math={"n"} /> = Número de questões vinculadas ao
                    princípio
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <InlineMath math={"w_i"} /> = Peso da questão{" "}
                    <InlineMath math={"i"} />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <InlineMath math={"a_k"} /> = Pontos da alternativa{" "}
                    <InlineMath math={"k"} /> marcada
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <InlineMath math={"S_i"} /> = Conjunto de alternativas
                    selecionadas na questão <InlineMath math={"i"} />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <InlineMath math={"I_{i}^{max}"} /> = Impacto máximo da
                    questão <InlineMath math={"i"} />
                  </Typography>
                </li>
              </ul>
            </Box>
          )}
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" gutterBottom>
            Definição de{" "}
            <span style={{ fontWeight: "bold" }}>Impacto Máximo</span> por
            questão:
          </Typography>
          <Box sx={{ fontSize: "0.85rem", color: blueGrey[900] }}>
            <BlockMath
              math={
                "I_{i}^{max} = \\begin{cases} 100 & \\text{se questão é múltipla escolha} \\\\ \\max(a_k) & \\text{se questão é escolha única} \\end{cases}"
              }
            />
          </Box>

          <Box>
            <Typography variant="body2">Onde:</Typography>
            <ul style={{ paddingLeft: 24, margin: 0, paddingTop: 8 }}>
              <li>
                <Typography variant="body2">
                  <InlineMath math={"max(a_k)"} /> = Valor de alternativa com
                  maior pontuação
                </Typography>
              </li>
            </ul>
          </Box>
        </Box>

        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            p: 2,
            borderRadius: 1,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography variant="body2" color={blueGrey[700]} fontWeight={600}>
            Exemplo Prático:
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    paddingBottom={0.4}
                    fontSize={"0.85rem"}
                  >
                    Questão 1
                  </Typography>

                  <Typography variant="body2" fontSize={"0.8rem"}>
                    Peso: 3
                  </Typography>
                </Box>
                <Typography variant="body2" fontSize={"0.8rem"}>
                  Tipo: Escolha única
                </Typography>
                <Typography
                  variant="body2"
                  fontSize={"0.8rem"}
                  paddingTop={0.3}
                >
                  Princípios: Transparência, Confiabilidade
                </Typography>
                <Typography
                  variant="body2"
                  fontSize={"0.8rem"}
                  display={"inline-flex"}
                  alignItems="center"
                  component="span"
                >
                  Alternativas: [20, 60, 90]
                  <ArrowRight size={"0.85rem"} style={{ marginInline: 4 }} />
                  Usuário marcou 60
                </Typography>
              </Box>

              <Box
                sx={{
                  fontSize: "0.8rem",
                  userSelect: "none",
                  "& .katex-display": { margin: 0 },
                  "& .mord": {
                    fontFamily: "Roboto",
                    fontSize: "0.9rem",
                    color: blueGrey[900],
                  },
                }}
              >
                <BlockMath math={"\\text{Pontuação} = 3 \\times 60 = 180"} />
                <BlockMath
                  math={"\\text{Impacto Máximo} = 3 \\times 90 = 270"}
                />
              </Box>
            </Box>

            <Divider sx={{ width: 140, margin: "0 auto" }} />

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    paddingBottom={0.4}
                    fontSize={"0.85rem"}
                  >
                    Questão 2
                  </Typography>

                  <Typography variant="body2" fontSize={"0.8rem"}>
                    Peso: 4
                  </Typography>
                </Box>

                <Typography variant="body2" fontSize={"0.8rem"}>
                  Tipo: Múltipla escolha
                </Typography>

                <Typography
                  variant="body2"
                  fontSize={"0.8rem"}
                  paddingTop={0.3}
                >
                  Princípios: Confiabilidade
                </Typography>

                <Typography
                  variant="body2"
                  fontSize={"0.8rem"}
                  display={"inline-flex"}
                  alignItems="center"
                  component="span"
                >
                  Alternativas: [10, 35, 25, 15, 15]
                  <ArrowRight size={"0.85rem"} style={{ marginInline: 4 }} />
                  Usuário marcou 35 e 15
                </Typography>
              </Box>

              <Box
                sx={{
                  fontSize: "0.8rem",
                  userSelect: "none",
                  "& .katex-display": { margin: 0 },
                  "& .mord": {
                    fontFamily: "Roboto",
                    fontSize: "0.9rem",
                    color: blueGrey[900],
                  },
                }}
              >
                <BlockMath
                  math={"\\text{Pontuação} = 4 \\times \\text(35 + 15) = 200"}
                />
                <BlockMath
                  math={"\\text{Impacto Máximo} = 4 \\times 100 = 400"}
                />
              </Box>
            </Box>

            <Divider sx={{ width: 140, margin: "0 auto" }} />

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    paddingBottom={0.4}
                    fontSize={"0.85rem"}
                  >
                    Questão 3
                  </Typography>

                  <Typography variant="body2" fontSize={"0.8rem"}>
                    Peso: 1
                  </Typography>
                </Box>

                <Typography variant="body2" fontSize={"0.8rem"}>
                  Tipo: Múltipla escolha
                </Typography>

                <Typography
                  variant="body2"
                  fontSize={"0.8rem"}
                  paddingTop={0.3}
                >
                  Princípios: Transparência, Confiabilidade
                </Typography>
                <Typography
                  variant="body2"
                  fontSize={"0.8rem"}
                  display={"inline-flex"}
                  alignItems="center"
                  component="span"
                >
                  Alternativas: [5, 10, 35, 20, 10, 15, 5]
                  <ArrowRight size={"0.85rem"} style={{ marginInline: 4 }} />
                  Usuário marcou 5 e 5
                </Typography>
              </Box>

              <Box
                sx={{
                  fontSize: "0.8rem",
                  userSelect: "none",
                  "& .katex-display": { margin: 0 },
                  "& .mord": {
                    fontFamily: "Roboto",
                    fontSize: "0.9rem",
                    color: blueGrey[900],
                  },
                }}
              >
                <BlockMath
                  math={"\\text{Pontuação} = 1 \\times \\text(5 + 5) = 10"}
                />
                <BlockMath
                  math={"\\text{Impacto Máximo} = 1 \\times 100 = 100"}
                />
              </Box>
            </Box>
          </Box>

          <Divider sx={{ width: "80%", margin: "0 auto" }} />

          <Typography variant="body2" fontWeight={600}>
            Cálculo Final
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box>
              <Typography
                variant="body2"
                fontWeight={600}
                paddingBottom={0.4}
                fontSize={"0.85rem"}
              >
                Transparência
              </Typography>
              <Box
                sx={{
                  fontSize: "0.8rem",
                  userSelect: "none",
                  "& .katex-display": { margin: 0 },
                  "& .mord": {
                    fontFamily: "Roboto",
                    fontSize: "0.8rem",
                    color: blueGrey[900],
                  },
                  "& .mord .mtight": {
                    fontSize: "0.5rem",
                  },
                }}
              >
                <BlockMath
                  math={
                    "\\text{Pontuação} = \\frac{Q_1 + Q_3}{I_1^{max} + I_3^{max}} \\times 100 = \\frac{180 + 40}{270 + 100} = \\frac{220}{370} \\times 100 = 59.4\\%"
                  }
                />
              </Box>
            </Box>
            <Box>
              <Typography
                variant="body2"
                fontWeight={600}
                paddingBottom={0.4}
                fontSize={"0.85rem"}
              >
                Confiabilidade
              </Typography>
              <Box
                sx={{
                  fontSize: "0.8rem",
                  userSelect: "none",
                  "& .katex-display": { margin: 0 },
                  "& .mord": {
                    fontFamily: "Roboto",
                    fontSize: "0.8rem",
                    color: blueGrey[900],
                  },
                  "& .mord .mtight": {
                    fontSize: "0.5rem",
                  },
                }}
              >
                <BlockMath
                  math={
                    "\\text{Pontuação} = \\frac{Q_1 + Q_2 + Q_3}{I_1^{max} + I_2^{max} + I_3^{max}} \\times 100 = \\frac{180 + 200 + 10}{270 + 400 + 100} = \\frac{390}{770} \\times 100 = 50.6\\%"
                  }
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
